import 'react';
import { jsx } from '@emotion/core';
import { ButtonGroup, Button } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import { DrawMode } from "../types/index.js";
import useStores from "../hooks/useStores.js";
import PdfToolbar from "./PdfToolbar.js";

var DrawablePdfToolbar = function DrawablePdfToolbar() {
  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  return jsx(PdfToolbar, null, jsx(ButtonGroup, {
    className: "me-2"
  }, jsx(Button, {
    "data-testid": "autofill",
    active: pdfStore.drawMode === DrawMode.Autofill,
    onClick: function onClick() {
      var _pdfStore$lastFieldCl;
      /* istanbul ignore next */


      (_pdfStore$lastFieldCl = pdfStore.lastFieldClicked) === null || _pdfStore$lastFieldCl === void 0 ? void 0 : _pdfStore$lastFieldCl.setInDefaultValueTypingMode(false);
      pdfStore.setDrawMode(DrawMode.Autofill);
    }
  }, "Merge Field"), jsx(Button, {
    "data-testid": "textField",
    active: pdfStore.drawMode === DrawMode.TextField,
    onClick: function onClick() {
      var _pdfStore$lastFieldCl2;
      /* istanbul ignore next */


      (_pdfStore$lastFieldCl2 = pdfStore.lastFieldClicked) === null || _pdfStore$lastFieldCl2 === void 0 ? void 0 : _pdfStore$lastFieldCl2.setInDefaultValueTypingMode(false);
      pdfStore.setDrawMode(DrawMode.TextField);
    }
  }, "Custom Field"), jsx(Button, {
    "data-testid": "checkbox",
    active: pdfStore.drawMode === DrawMode.Checkbox,
    onClick: function onClick() {
      var _pdfStore$lastFieldCl3;
      /* istanbul ignore next */


      (_pdfStore$lastFieldCl3 = pdfStore.lastFieldClicked) === null || _pdfStore$lastFieldCl3 === void 0 ? void 0 : _pdfStore$lastFieldCl3.setInDefaultValueTypingMode(false);
      pdfStore.setDrawMode(DrawMode.Checkbox);
    }
  }, "Checkbox"), jsx(Button, {
    "data-testid": "signature",
    active: pdfStore.drawMode === DrawMode.Signature,
    onClick: function onClick() {
      var _pdfStore$lastFieldCl4;
      /* istanbul ignore next */


      (_pdfStore$lastFieldCl4 = pdfStore.lastFieldClicked) === null || _pdfStore$lastFieldCl4 === void 0 ? void 0 : _pdfStore$lastFieldCl4.setInDefaultValueTypingMode(false);
      pdfStore.setDrawMode(DrawMode.Signature);
    }
  }, "Signature"), jsx(Button, {
    "data-testid": "initials",
    active: pdfStore.drawMode === DrawMode.Initials,
    onClick: function onClick() {
      var _pdfStore$lastFieldCl5;
      /* istanbul ignore next */


      (_pdfStore$lastFieldCl5 = pdfStore.lastFieldClicked) === null || _pdfStore$lastFieldCl5 === void 0 ? void 0 : _pdfStore$lastFieldCl5.setInDefaultValueTypingMode(false);
      pdfStore.setDrawMode(DrawMode.Initials);
    }
  }, "Initials"), jsx(Button, {
    "data-testid": "dateSigned",
    active: pdfStore.drawMode === DrawMode.DateSigned,
    onClick: function onClick() {
      var _pdfStore$lastFieldCl6;
      /* istanbul ignore next */


      (_pdfStore$lastFieldCl6 = pdfStore.lastFieldClicked) === null || _pdfStore$lastFieldCl6 === void 0 ? void 0 : _pdfStore$lastFieldCl6.setInDefaultValueTypingMode(false);
      pdfStore.setDrawMode(DrawMode.DateSigned);
    }
  }, "Date Signed")), jsx("div", null, jsx(Button, {
    className: "p-0 mt-2",
    color: "link",
    onClick: function onClick() {
      var _pdfStore$lastFieldCl7;

      document.activeElement.blur();
      /* istanbul ignore next */

      (_pdfStore$lastFieldCl7 = pdfStore.lastFieldClicked) === null || _pdfStore$lastFieldCl7 === void 0 ? void 0 : _pdfStore$lastFieldCl7.setInDefaultValueTypingMode(false);
      pdfStore.setDrawMode();
    }
  }, "Clear field type selection")));
};

DrawablePdfToolbar.displayName = "DrawablePdfToolbar";
var DrawablePdfToolbar$1 = observer(DrawablePdfToolbar);
export default DrawablePdfToolbar$1;